import React from "react";
import Grid from "@material-ui/core/Grid";
import { sto } from "../../../../Context/InshData";
import { useInvMain } from "../../../../St/Reviews/UseStyle";
import { styleFooterNotesAr } from "../../ShareFunctionsPrint";
function FooterDev(props) {
    const { inv } = props;
    const clasm = useInvMain();
    const styfC = { fontSize: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular", paddingBottom: "0.3rem" };

    return (
        <Grid item container
            style={{ padding: 5, fontWeight: "bold", fontFamily: "Amiri-Regular", marginLeft: "0cm", fontFamily: "Amiri-Regular" }}
        >
            <Grid item container xs={12} style={{ fontWeight: "bold", }}  >
                <Grid item xs={12} container  >
                    <Grid item xs={12} className={clasm.minrit} style={{ direction: "ltr", textAlign: "left", paddingTop: "0.5rem" }}>
                        <div style={styfC}>{"Terms, Condations & Other Information"}  {sto.usernames}</div>
                    </Grid>
                    <Grid item xs={12} style={styleFooterNotesAr}  >
                        {inv.notes}
                    </Grid>
                    <br />
                    <Grid item xs={12} container style={{ paddingTop: "1rem" }} >
                        <Grid item xs={6} container  >

                            <Grid item xs={12} className={clasm.minrit} style={{ direction: "ltr", textAlign: "left", paddingTop: "0.5rem" }}>
                                <div style={styfC}>{"Received and Accepted"}</div>
                            </Grid>
                            <Grid item xs={12} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.3rem" }}>
                                {"Name :"}
                            </Grid>
                            <Grid item xs={12} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.3rem" }}>
                                {"Signature :"}
                            </Grid>
                        </Grid>
                        <Grid item xs={6} container  >

                            <Grid item xs={12} className={clasm.minrit} style={{ direction: "ltr", textAlign: "left", paddingTop: "0.5rem" }}>
                                <div style={styfC}>{"Transporter Name : "}  {sto.usernames}</div>
                            </Grid>
                            <Grid item xs={12} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.3rem" }}>
                                {"Vehicle No :"}
                            </Grid>
                            <Grid item xs={12} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.3rem" }}>
                                {"Signature :"}
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>

            </Grid>

        </Grid>

    );
}
export default FooterDev;

